/* ============================================================
   KILIMUKAS THEME — theme.js
   ============================================================ */

(function () {
  'use strict';

  /* ---- CART STATE ---- */
  let cartState = { token: null, items: [], total_price: 0, item_count: 0 };

  /* ---- DOM refs ---- */
  const cartToggle   = document.getElementById('cartToggle');
  const cartClose    = document.getElementById('cartClose');
  const cartOverlay  = document.getElementById('cartOverlay');
  const cartDrawer   = document.getElementById('cartDrawer');
  const cartCount    = document.getElementById('cartCount');
  const cartBody     = document.getElementById('cartBody');
  const cartEmpty    = document.getElementById('cartEmpty');
  const cartItemsEl  = document.getElementById('cartItems');
  const cartFooter   = document.getElementById('cartFooter');
  const cartTotalEl  = document.getElementById('cartTotal');
  const checkoutBtn  = document.getElementById('checkoutBtn');

  /* ---- Toast ---- */
  let toastContainer = document.querySelector('.toast-container');
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.className = 'toast-container';
    document.body.appendChild(toastContainer);
  }

  function showToast(msg) {
    const t = document.createElement('div');
    t.className = 'toast';
    t.textContent = msg;
    toastContainer.appendChild(t);
    requestAnimationFrame(() => { t.classList.add('show'); });
    setTimeout(() => {
      t.classList.remove('show');
      setTimeout(() => t.remove(), 300);
    }, 2800);
  }

  /* ---- Format money ---- */
  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* ---- Cart drawer toggle ---- */
  function openCart() {
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeCart() {
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose)  cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ---- Fetch cart from Shopify ---- */
  function fetchCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(data => {
        cartState = data;
        renderCart();
        updateCartCount(data.item_count);
      })
      .catch(() => {});
  }

  /* ---- Render cart drawer ---- */
  function renderCart() {
    const items = cartState.items || [];
    if (items.length === 0) {
      cartEmpty.style.display = 'flex';
      cartItemsEl.innerHTML = '';
      cartFooter.style.display = 'none';
    } else {
      cartEmpty.style.display = 'none';
      cartFooter.style.display = 'flex';
      cartTotalEl.textContent = formatMoney(cartState.total_price);
      cartItemsEl.innerHTML = items.map((item, idx) => `
        <div class="cart-drawer-item" data-key="${item.key}">
          <div class="cart-drawer-item-img">
            ${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.title)}" loading="lazy" />` : ''}
          </div>
          <div class="cart-drawer-item-info" style="flex:1;min-width:0">
            <div class="cart-drawer-item-title">${escapeHtml(item.product_title)}</div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer-item-variant">${escapeHtml(item.variant_title)}</div>` : ''}
            <div class="cart-drawer-item-price">${formatMoney(item.price)}</div>
            <div class="cart-drawer-item-controls">
              <button class="drawer-qty-btn" data-action="minus" data-key="${item.key}" data-qty="${item.quantity}">−</button>
              <span class="drawer-qty-val">${item.quantity}</span>
              <button class="drawer-qty-btn" data-action="plus" data-key="${item.key}" data-qty="${item.quantity}">+</button>
            </div>
          </div>
          <button class="cart-drawer-item-remove" data-key="${item.key}" aria-label="Pašalinti">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
      `).join('');

      /* bind qty/remove events */
      cartItemsEl.querySelectorAll('.drawer-qty-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const key = btn.dataset.key;
          const qty = parseInt(btn.dataset.qty);
          const newQty = btn.dataset.action === 'plus' ? qty + 1 : Math.max(0, qty - 1);
          updateCartItem(key, newQty);
        });
      });
      cartItemsEl.querySelectorAll('.cart-drawer-item-remove').forEach(btn => {
        btn.addEventListener('click', () => updateCartItem(btn.dataset.key, 0));
      });
    }
  }

  /* ---- Update cart item ---- */
  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    })
      .then(r => r.json())
      .then(data => {
        cartState = data;
        renderCart();
        updateCartCount(data.item_count);
      });
  }

  /* ---- Add to cart ---- */
  function addToCart(variantId, quantity = 1) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    })
      .then(r => {
        if (!r.ok) throw new Error('Add failed');
        return r.json();
      })
      .then(() => {
        fetchCart();
        openCart();
        showToast('Pridėta į krepšelį ✓');
      })
      .catch(() => showToast('Klaida – bandykite dar kartą'));
  }

  /* ---- Update cart badge ---- */
  function updateCartCount(count) {
    if (!cartCount) return;
    if (count > 0) {
      cartCount.textContent = count;
      cartCount.style.display = 'flex';
    } else {
      cartCount.style.display = 'none';
    }
  }

  /* ---- Delegate "add to cart" buttons on product grids ---- */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.btn-add-cart');
    if (btn && !btn.disabled) {
      e.preventDefault();
      const id = btn.dataset.productId;
      if (id) addToCart(parseInt(id));
    }
  });

  /* ---- Product page: variant selection + add to cart form ---- */
  const variantsScript = document.getElementById('productVariants');
  if (variantsScript) {
    let variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (_) {}

    const variantBtns = document.querySelectorAll('.variant-btn');
    const selectedVariantInput = document.getElementById('selectedVariantId');
    const addToCartBtn = document.getElementById('addToCartBtn');
    const selectedPriceEl = document.getElementById('selectedPrice');
    const addToCartForm = document.getElementById('addToCartForm');

    /* Track selected options */
    const selectedOptions = {};
    variantBtns.forEach(btn => {
      const pos = btn.dataset.option;
      if (!selectedOptions[pos]) selectedOptions[pos] = btn.dataset.value;
    });

    function findMatchingVariant() {
      return variants.find(v => {
        return Object.entries(selectedOptions).every(([pos, val]) => {
          return v['option' + pos] === val;
        });
      }) || null;
    }

    function updateSelectedVariant() {
      const match = findMatchingVariant();
      if (!selectedVariantInput || !addToCartBtn) return;
      if (match) {
        selectedVariantInput.value = match.id;
        if (selectedPriceEl) selectedPriceEl.textContent = formatMoney(match.price);
        if (match.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Į krepšelį';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Išparduota';
        }
        /* Switch image when variant has its own photo */
        if (match.featured_image) {
          const mainImg = document.getElementById('mainImage');
          if (mainImg && mainImg.src !== match.featured_image) {
            mainImg.src = match.featured_image;
            const thumbs = document.querySelectorAll('.gallery-thumb');
            thumbs.forEach(t => {
              t.classList.remove('active');
              if (t.dataset.src === match.featured_image) t.classList.add('active');
            });
          }
        }
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Nepasiekiama';
      }
    }

    variantBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const pos = btn.dataset.option;
        /* deselect siblings */
        document.querySelectorAll(`.variant-btn[data-option="${pos}"]`).forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        selectedOptions[pos] = btn.dataset.value;
        updateSelectedVariant();
      });
    });

    /* Intercept form submit → AJAX add to cart */
    if (addToCartForm) {
      addToCartForm.addEventListener('submit', function (e) {
        e.preventDefault();
        const id = parseInt(selectedVariantInput.value);
        if (id) addToCart(id);
      });
    }
  }

  /* ---- Product page: image gallery ---- */
  const thumbs = document.querySelectorAll('.gallery-thumb');
  const mainImage = document.getElementById('mainImage');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImage) {
        mainImage.src = thumb.dataset.src;
        mainImage.alt = thumb.dataset.alt || '';
      }
    });
  });

  /* ---- Cart page: qty controls ---- */
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const line = btn.dataset.line;
      const input = document.querySelector(`.qty-input[data-line="${line}"]`);
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (btn.classList.contains('qty-plus')) val++;
      else val = Math.max(0, val - 1);
      input.value = val;
    });
  });

  /* ---- Smooth scroll for hero CTA ---- */
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', e => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });


  /* ---- Search overlay ---- */
  const searchToggle = document.getElementById('searchToggle');
  const searchOverlay = document.getElementById('searchOverlay');
  const searchClose = document.getElementById('searchClose');
  const searchInput = document.getElementById('searchInput');

  function openSearch() {
    searchOverlay.classList.add('open');
    setTimeout(() => searchInput && searchInput.focus(), 280);
  }
  function closeSearch() {
    searchOverlay.classList.remove('open');
  }

  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchOverlay.classList.contains('open')) closeSearch();
  });

  /* ---- Initial cart count load ---- */
  fetchCart();

  /* ---- Utility ---- */
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

})();
